import type {
  MunicipalListAccommodation,
  PreRegistrationStatusCode,
} from '../types/pre-registration.types';

// Stable status ids of the backend catalog (GET /accommodation-statuses)
export const PRE_REGISTRATION_STATUS_IDS: Record<PreRegistrationStatusCode, number> = {
  pending_review: 1,
  to_regularize: 2,
  already_registered: 3,
  regularized: 4,
  deleted: 5,
};

export interface StatusAction {
  target: PreRegistrationStatusCode;
  label: string;
  // Deleting asks for a reason that replaces the row's observations
  asksReason?: boolean;
}

// Transitions that need no official accommodation. "Ya registrado" / "Regularizado" are added
// by the official REPAT lookup (KER-568).
export const MANUAL_STATUS_ACTIONS: Record<PreRegistrationStatusCode, StatusAction[]> = {
  pending_review: [
    { target: 'to_regularize', label: 'Pasar a A regularizar' },
    { target: 'deleted', label: 'Eliminar…', asksReason: true },
  ],
  to_regularize: [
    { target: 'pending_review', label: 'Volver a Pendiente de control' },
    { target: 'deleted', label: 'Eliminar…', asksReason: true },
  ],
  already_registered: [{ target: 'pending_review', label: 'Volver a Pendiente de control' }],
  regularized: [{ target: 'to_regularize', label: 'Volver a A regularizar' }],
  deleted: [{ target: 'pending_review', label: 'Restaurar' }],
};

const EDITABLE_STATUSES: PreRegistrationStatusCode[] = ['pending_review', 'to_regularize'];

export const isRowDataEditable = (code: PreRegistrationStatusCode): boolean =>
  EDITABLE_STATUSES.includes(code);

export const isRowDeleted = (row: Pick<MunicipalListAccommodation, 'status'>): boolean =>
  row.status.code === 'deleted';

export const countPendingNotification = (rows: MunicipalListAccommodation[]): number =>
  rows.filter((row) => !isRowDeleted(row) && row.notifiedAt === null).length;

// Rows already sent to Fiscalización, deleted ones included; any of them blocks deleting the list
export const countNotified = (rows: MunicipalListAccommodation[]): number =>
  rows.filter((row) => row.notifiedAt !== null).length;
